import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/comics";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="mx-auto max-w-[1200px] px-4 md:px-6 py-14 md:py-20">
      <div className="text-center">
        <p className="text-sm font-medium text-primary-600">FAQ</p>
        <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h2>
        <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
          关于榜单更新、分类筛选与选书的小疑问，这里都有答案。
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-3xl divide-y divide-background-200/70 rounded-lg bg-background-100 px-5 md:px-6">
        {faqs.map((f, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={f.q}>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : i)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 py-4 text-left"
              >
                <span className="text-sm font-medium text-foreground-950 md:text-base">{f.q}</span>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform ${isOpen ? "rotate-45" : ""}`}>
                  <i className="ri-add-line"></i>
                </span>
              </button>
              {isOpen && (
                <p className="pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-8 text-center">
        <Link to="/faq" className="text-sm font-medium text-primary-600 hover:text-primary-700">
          查看全部常见问题 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}